webpackJsonp([226020273838829],{

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/enterprise.aa4ace8a.svg";

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/growth.262439e5.svg";

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/rocket-on-back.414dca2b.svg";

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/startup.a130abda.svg";

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectIsMobile = function injectIsMobile(Child) {
	  return function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	      _this.state = { isMobile: false };
	
	      _this.onResize = _this.onResize.bind(_this);
	      return _this;
	    }
	
	    _class.prototype.componentWillMount = function componentWillMount() {
	      var resizeListener = typeof window !== 'undefined' && window.addEventListener('resize', this.onResize);
	      this.onResize();
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      typeof window !== 'undefined' && window.removeEventListener('resize', this.onResize);
	    };
	
	    _class.prototype.onResize = function onResize() {
	      var isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
	      this.setState({ isMobile: isMobile });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement(Child, _extends({ isMobile: this.state.isMobile }, this.props));
	    };
	
	    return _class;
	  }(_react2.default.Component);
	};
	
	exports.default = injectIsMobile;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(22);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Column = function Column(_ref) {
	  var illustration = _ref.illustration,
	      title = _ref.title,
	      monthlyPrice = _ref.monthlyPrice,
	      annualPrice = _ref.annualPrice,
	      features = _ref.features,
	      free = _ref.free,
	      contactUs = _ref.contactUs;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'h5 tc relative' },
	      _react2.default.createElement(
	        'div',
	        { className: 'absolute tc bottom-0 w-100' },
	        _react2.default.createElement('img', { src: illustration })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'f4 mt2 tc black-60' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'h4 dt w-100' },
	      _react2.default.createElement(
	        'div',
	        { className: 'dtc v-mid tc' },
	        _react2.default.createElement(
	          'div',
	          { className: '' },
	          _react2.default.createElement(
	            'div',
	            { className: 'f2 mt3' },
	            contactUs ? _react2.default.createElement(
	              'span',
	              null,
	              'Bespoke'
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'f4 v-mid' },
	                '$'
	              ),
	              ' ',
	              annualPrice,
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { className: 'black-60 f5' },
	                '/m'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'f6 ph1 black-40' },
	            free ? 'free forever' : contactUs ? 'pricing that fits your need' : _react2.default.createElement(
	              'span',
	              null,
	              'billed annually or $ ',
	              monthlyPrice,
	              ' per month'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mt2' },
	      features && features.map(function (f, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: 'f6 mb3 ph3' },
	          f
	        );
	      })
	    )
	  );
	};
	
	exports.default = Column;
	module.exports = exports['default'];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(22);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _rocketOnBack = __webpack_require__(137);
	
	var _rocketOnBack2 = _interopRequireDefault(_rocketOnBack);
	
	var _injectIsMobile = __webpack_require__(18);
	
	var _injectIsMobile2 = _interopRequireDefault(_injectIsMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ReadyToTry = function ReadyToTry(_ref) {
	  var isMobile = _ref.isMobile;
	  return _react2.default.createElement(
	    'div',
	    { className: 'tc pv6', style: {} },
	    _react2.default.createElement(
	      'div',
	      { className: 'pv4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray f4 mb3' },
	        'Ready to try Speer ?'
	      ),
	      _react2.default.createElement(_button2.default, { label: 'Get started', href: '', backgroundColor: 'blue', size: 'large' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'lighter-gray f6 mt1 pl2' },
	        'Free for 7 days, no card required'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'fr', style: { marginTop: isMobile ? 8 : -199 } },
	      _react2.default.createElement('img', { src: _rocketOnBack2.default, className: '' + (isMobile ? 'h4' : '') })
	    )
	  );
	};
	
	exports.default = (0, _injectIsMobile2.default)(ReadyToTry);
	module.exports = exports['default'];

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bgVariations = {
	  blue: { backgroundColor: '#2a52d2', color: '#fff' },
	  white: { border: '1px solid #999' }
	};
	
	var sizeVariations = {
	  small: 'pv2 ph4 f4',
	  large: 'pv3 ph5 f3'
	};
	
	var Button = function Button(_ref) {
	  var label = _ref.label,
	      href = _ref.href,
	      backgroundColor = _ref.backgroundColor,
	      size = _ref.size;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: href },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'br-pill b dib bw2 grow ' + sizeVariations[size ? size : 'small'],
	          style: bgVariations[backgroundColor]
	        },
	        label
	      )
	    )
	  );
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _column = __webpack_require__(219);
	
	var _column2 = _interopRequireDefault(_column);
	
	var _seed = __webpack_require__(464);
	
	var _seed2 = _interopRequireDefault(_seed);
	
	var _startup = __webpack_require__(465);
	
	var _startup2 = _interopRequireDefault(_startup);
	
	var _growth = __webpack_require__(460);
	
	var _growth2 = _interopRequireDefault(_growth);
	
	var _enterprise = __webpack_require__(459);
	
	var _enterprise2 = _interopRequireDefault(_enterprise);
	
	var _readyToTry = __webpack_require__(76);
	
	var _readyToTry2 = _interopRequireDefault(_readyToTry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var plans = [{
	  illustration: _seed2.default,
	  title: 'Seed',
	  monthlyPrice: 0,
	  annualPrice: 0,
	  free: true,
	  features: ['20 active conversations']
	}, {
	  illustration: _startup2.default,
	  title: 'Startup',
	  monthlyPrice: 42,
	  annualPrice: 40,
	  features: ['500 active conversations', '72 hour email support', 'White labeled document viewer']
	}, {
	  illustration: _growth2.default,
	  title: 'Growth',
	  monthlyPrice: 220,
	  annualPrice: 200,
	  features: ['3000 active conversations', '12 hour email support', 'Phone support', 'White labeled document viewer']
	}, {
	  illustration: _enterprise2.default,
	  title: 'Enterprise',
	  monthlyPrice: 0,
	  annualPrice: 0,
	  contactUs: true,
	  features: ['Unlimited active conversations', 'Dedicated account manager', 'White labeled document viewer', 'On premise hosting']
	}];
	
	var Pricing = function Pricing() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'f2 tc' },
	      'Pricing Guide'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'f4 w-80 w-40-ns mt3 tc center lighter-gray' },
	      'All plans include unlimited user accounts.',
	      _react2.default.createElement('br', null),
	      'The only limit is on the number of active conversations.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cf w-100 w-70-ns center-ns' },
	      plans.map(function (p, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: 'w-100 w-25-ns fl-ns' },
	          _react2.default.createElement(_column2.default, p)
	        );
	      })
	    ),
	    _react2.default.createElement(_readyToTry2.default, null)
	  );
	};
	
	exports.default = Pricing;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-1b9eff1e6a1193b8ad25.js